import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteOffer = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}offers/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteOffer;
